import type { AsyncSequence } from "../types/AsyncSequence"

export async function* MapAsync<T, N>(
  func: (item: T, index: number) => N | Promise<N>,
  ...arrays: AsyncSequence<T>[]
): AsyncGenerator<N> {
  let index = 0
  for (const array of arrays) {
    for await (const item of array) {
      yield await func(item, index++)
    }
  }
}
